import * as yup from 'yup'

import { pageNum, pageSize, requiredString } from '../yup/schemas.js'

export const representativeSchema = yup.object({
  id: requiredString.uuid(),
  name: requiredString,
  email: requiredString.email().toLowerCase(),
  password: requiredString.password()
}).objectRequired()

const getRepresentativeSchoolListQueryParams = yup.object({ pageNum, pageSize }).objectRequired()

const getRepresentativeParamsSchema = representativeSchema.pick(['id'])

const getByEmailParamsSchemas = {
  back: representativeSchema.pick(['email'])
}

const patchRepresentativeSchema = representativeSchema
  .pick(['name', 'email', 'password'])
  .allFieldsOptional()

const getRepresentativeParamsSchemas = { back: getRepresentativeParamsSchema }
const patchRepresentativeSchemas = { back: patchRepresentativeSchema, front: patchRepresentativeSchema }
const getRepresentativeSchoolListQueryParamsSchemas = { front: getRepresentativeSchoolListQueryParams, back: getRepresentativeSchoolListQueryParams }

export default {
  patchRepresentative: patchRepresentativeSchemas,
  getByEmailParams: getByEmailParamsSchemas,
  getRepresentativeSchoolListQueryParams: getRepresentativeSchoolListQueryParamsSchemas,
  getRepresentativeParams: getRepresentativeParamsSchemas
}
